import { store } from '@/store'
import * as Sentry from '@sentry/vue'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext, LocationQuery } from 'vue-router'

export default async function (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext
) {
  try {
    setSelectedContextFromQuery(to.query)

    await store.dispatch('session/restoreStudioSession', { from, to })
    const isOnboardingUserDetails = store.state.session.isOnboardingUserDetails
    const isOnboardingAssignments = store.state.session.isOnboardingAssignments
    if (isOnboardingAssignments || isOnboardingUserDetails) {
      if (to.name !== 'onboarding') {
        next({ name: 'onboarding' })
      } else {
        next()
      }
    } else if (to.name === 'onboarding') {
      next('/')
    } else {
      next()
    }
  } catch (error) {
    Sentry.withScope(scope => {
      scope.setTag('feature', 'isAuthenticated-middleware')
      Sentry.captureException(error)
    })

    return next()
  }
}

export function extractMarketingLinkIds(query: LocationQuery = {}) {
  let organisationId = ''
  let accommodationId = ''

  for (const [key, value] of Object.entries(query)) {
    if (typeof value !== 'string' || !value) continue

    const normalizedKey = key.toLowerCase()
    if (normalizedKey === 'orgid' || normalizedKey === 'org_id') organisationId = value
    if (normalizedKey === 'itemid' || normalizedKey === 'item_id') accommodationId = value
  }

  return { organisationId, accommodationId }
}

function setSelectedContextFromQuery(query: LocationQuery = {}) {
  const { organisationId, accommodationId } = extractMarketingLinkIds(query)

  if (organisationId) {
    window.localStorage.setItem('selected_organisation_id', organisationId)
  }
  if (accommodationId) {
    window.localStorage.setItem('selected_accommodation_id', accommodationId)
  }
}
